// Minimal updateUsers for writing a single key into the `Users.settings` AWSJSON blob.
//
// Selects only `id` on purpose: the caller already knows the settings it just wrote, and a
// smaller selection set keeps the mutation cheap. Deliberately NOT imported from the generated
// src/graphql/mutations.js, which is ~28 MB.
//
// Only ever send `{ id, settings }` in the input. `Users` carries field-level @auth (on id,
// companyId, contactPersonUserId, email, forms, roleId), which makes this a complex auth
// resolver where any `null` input field is rejected with "Unauthorized on [field]".
export const updateUserSettings = /* GraphQL */ `
  mutation UpdateUserSettings($input: UpdateUsersInput!) {
    updateUsers(input: $input) {
      id
    }
  }
`;
